import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import getEnvEndpoints from "../../utils/endpoints";

const endpoints = getEnvEndpoints();

export const SIGNIN_OIDC_PATH = "/signin-oidc";
export const DEFAULT_RETURN_PATH = "/home";

const withOfflineAccess = (scope = "") => {
  const scopes = scope.split(" ").filter(Boolean);
  if (!scopes.includes("offline_access")) {
    scopes.push("offline_access");
  }
  return scopes.join(" ");
};

// Matches ASCII control characters (tabs, CR, LF, etc.) that browsers strip/normalize and that
// could otherwise be used to smuggle a path past the same-origin prefix checks below.
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_REGEX = /[\x00-\x1f\x7f]/;

// Only same-origin relative paths are honoured so a crafted ?redirect= can't send users off-site.
export const toSafeReturnPath = (path) =>
  typeof path === "string" &&
  path.startsWith("/") &&
  !path.startsWith("//") &&
  !path.startsWith("/\\") &&
  !CONTROL_CHARS_REGEX.test(path)
    ? path
    : DEFAULT_RETURN_PATH;

const settings = {
  authority: endpoints.idpBaseUrl,
  client_id: endpoints.clientID,
  redirect_uri: `${window.location.origin}${SIGNIN_OIDC_PATH}`,
  post_logout_redirect_uri: window.location.origin,
  response_type: "code",
  scope: withOfflineAccess(endpoints.scope),
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,

  extraHeaders: {
    Authorization: `Basic ${btoa(endpoints.clientID || "")}`,
  },
};

export const getIdentityLogoutUrl = () =>
  `${endpoints.idpBaseUrl}/account/logout?clientid=${encodeURIComponent(endpoints.clientID)}&returnurl=${encodeURIComponent(window.location.origin)}`;

const userManager = new UserManager(settings);

// Starts the redirect-based authorization code + PKCE sign-in flow. The path to return to
// after sign-in travels through the IdP as OIDC state rather than a query string.
export const startSignIn = (returnTo) =>
  userManager.signinRedirect({ state: { returnTo: toSafeReturnPath(returnTo) } }).catch((error) => {
    console.error("OIDC sign-in redirect failed:", error);
  });

export default userManager;
